import { render, staticRenderFns } from "./IconTechnisch.vue?vue&type=template&id=a675721c"
import script from "./IconTechnisch.vue?vue&type=script&lang=ts"
export * from "./IconTechnisch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports